import { render, staticRenderFns } from "./TotalInvoicesStatement.vue?vue&type=template&id=4a78fc7f"
import script from "./TotalInvoicesStatement.vue?vue&type=script&lang=js"
export * from "./TotalInvoicesStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports